<div class="main">
  <div style="min-height: 50vh; width: 100vw" *ngIf="isLoadingPerforations">
    <div class="loading-shade">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div class="general-data">
    <table>
      <thead>
        <tr>
          <th>Wellbore</th>
          <th>Tope superior [m]</th>
          <th>Base Inferior [m]</th>
        </tr>
      </thead>
      <tbody *ngIf="perforationsByWellboreLenght">
        <tr *ngFor="let pfWb of perforationsByWellbore | keyvalue">
          <td>{{ pfWb.value[0].wellboreNo }}</td>
          <td>{{ pfWb.value[0].mdTop | number : "1.2-2" }}</td>
          <td>
            {{ pfWb.value[pfWb.value.length - 1].mdBase | number : "1.2-2" }}
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="!perforationsByWellboreLenght" class="no-data">
      <h3>No se encontraron datos</h3>
      <p>
        De existir datos en el sistema de<br />origen, podrás visualizarlos acá
      </p>
    </div>
  </div>
  <div class="container" *ngIf="!isLoadingPerforations">
    <table mat-table [dataSource]="perforations" class="perforation-table">
      <ng-container matColumnDef="wellboreNo">
        <mat-header-cell *matHeaderCellDef> Wellbore </mat-header-cell>
        <mat-cell *matCellDef="let perforation">
          {{ perforation.wellboreNo }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="mdTop">
        <mat-header-cell *matHeaderCellDef>
          MD Tope Intervalo [m]
        </mat-header-cell>
        <mat-cell *matCellDef="let perforation">
          {{ perforation.mdTop | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="mdBase">
        <mat-header-cell *matHeaderCellDef>
          MD Base Intervalo [m]
        </mat-header-cell>
        <mat-cell *matCellDef="let perforation">
          {{ perforation.mdBase | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="jobEnd">
        <mat-header-cell *matHeaderCellDef> Fecha </mat-header-cell>
        <mat-cell *matCellDef="let perforation">
          {{ perforation.jobEnd | date : "dd/MM/yyyy" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="numIntervals">
        <mat-header-cell *matHeaderCellDef> Num. Intervalos </mat-header-cell>
        <mat-cell *matCellDef="let perforation">
          {{ perforation.numIntervals }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="shotDensityAverage">
        <mat-header-cell *matHeaderCellDef>
          Densidad de <br />
          tiros [tiros/m]
        </mat-header-cell>
        <mat-cell *matCellDef="let perforation">
          {{ perforation.shotDensityAverage | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="carrierSizeAvg">
        <mat-header-cell *matHeaderCellDef>
          Calibre de Cañon [pulg]
        </mat-header-cell>
        <mat-cell *matCellDef="let perforation">
          {{ perforation.carrierSizeAvg }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="chargeSizeAvg">
        <mat-header-cell *matHeaderCellDef>
          Peso de la Carga [gr]
        </mat-header-cell>
        <mat-cell *matCellDef="let perforation">
          {{ perforation.chargeSizeAvg }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="noData">
        <mat-footer-cell *matFooterCellDef colspan="4">
          <div class="footer">
            <div class="footer-no-data">No se encontraron datos.</div>
            <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">
              De existir datos en el sistema de origen, podrás visualizarlos
              acá.
            </div>
          </div>
        </mat-footer-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
      ></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      <mat-footer-row
        *matFooterRowDef="['noData']"
        [ngClass]="{ 'hide-footer': hideFooter }"
      ></mat-footer-row>
    </table>
  </div>
</div>
<app-handover-detail-perforation-icp
  [handoverId]="handoverId"
  [wellUwi]="wellUwi"
  [handoverStatusId]="handoverStatusId"
></app-handover-detail-perforation-icp>
